export default {
    setAlertRecord(state, data) {
        state.alertRecord = data
    },
}
